// tslint:disable:max-line-length

import React from 'react';

export const StatusWarning = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M15.9,14.5L9,0.6C8.9,0.4,8.7,0.3,8.5,0.2c0,0,0,0,0,0C7.9-0.1,7.3,0.1,7,0.6L0.2,14.5C0.1,14.6,0,14.8,0,15 C0,15.5,0.5,16,1.1,16H15c0.2,0,0.3,0,0.5-0.1c0,0,0,0,0,0C16,15.6,16.2,15,15.9,14.5z M9,14.7H7v-2h2V14.7z M9,11.7H7v-7h2V11.7z" />
    </svg>
  );
};
